import {TYPE_OTHER} from '../constants';

const lower = srt => srt.toLowerCase();

export const sortByNameAndLanguage = data => {
  const sortedData = data.sort((a, b) =>
    lower(b.groupName) > lower(a.groupName) ? -1 : 1,
  );

  const getWithLang = lang => sortedData.filter(item => item.language === lang);

  return [
    ...getWithLang('English'),
    ...getWithLang('Czech'), // @todo: should be Čeština?
    ...getWithLang('Deutsch'),
    ...getWithLang('Español'),
    ...getWithLang('Français'),
    ...getWithLang('Italiano'),
    ...getWithLang('Português'),
    ...getWithLang('Türkçe'),
    ...getWithLang('Русский'),
    ...getWithLang('日本語'),
    ...getWithLang('简体中文'),
    ...getWithLang('한국어'),
  ];
};

export const sortByNameWithOther = data => {
  const d = data
    .filter(item => item !== TYPE_OTHER)
    .sort((a, b) => b < a ? 1 : -1);

  d.push('Other');

  return d;
};

export const sortByName = data => data.sort((a, b) => (b < a ? 1 : -1));
